export default "__VITE_ASSET__fd3b5a28__"